









































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { choice } from "@modules/newCommunity/pages/operationTools/pages/questionnaireEdit/validateUtils/newIndex";
import draggable from "vuedraggable";
import questionSettingTemplate from "./questionSettingTemplate.vue";
import PicUpload from "@/components/picUpload/index.vue";
import EditSortDialog from "@/modules/newCommunity/pages/operationTools/pages/questionnaire/components/EditSortDialog.vue";
import { QuestionnaireEditModule } from "@/modules/newCommunity/pages/operationTools/dynimicStore/newIndex";
import { EnumCommunityType } from "@modules/newCommunity/pages/operationTools/api/questionnaire";

interface IScoreVerificationRule {
  operate: string;
  score: number | null;
  verificationResult: string;
}

@Component({
  name: "calculator",
  components: {
    PicUpload,
    questionSettingTemplate,
    draggable,
    EditSortDialog,
  },
})
export default class calculator extends Vue {
  @Prop({
    type: Object,
    default() {
      return {};
    },
  })
  value!: any;
  @Prop({
    type: Boolean,
    default: false,
  })
  disabled?: any;

  @Watch("value", { deep: true, immediate: true })
  watchPropData() {
    if (JSON.stringify(this.value) != JSON.stringify(this.postForm)) {
      const postForm = JSON.parse(JSON.stringify(this.value));
      this.postForm = postForm;
    }
  }
  private editSortDialogKey = Math.random();
  private drag = false;
  private loading = false;
  private catalogList: any[] = [];
  private postForm: any = {
    title: "请选择以下选项", // 标题
    required: 0, // 是否必填
    // 是否必填

    jsonConfig: {
      showIndex: true,
      addCalculatorList: [],
      scoreVerificationEnabled: false,
      scoreVerificationList: [],
    },
  };
  private optionValidator = choice.content;
  private rules = {
    title: [{ required: true, message: "请输入标题", type: "string", trigger: "blur" }],

    "jsonConfig.calculatorList": [{ required: true, type: "array", message: "编辑计算公式" }],
    // catalogIds: [{ required: true, type: "array", message: "请选择分类名", trigger: "blur" }],
    whetherJoinQuestionBank: [{ required: true, message: "请选择是否加入题库", trigger: "blur" }],
  };
  @Watch("postForm", { deep: true })
  watchPostForm() {
    const backup = JSON.parse(JSON.stringify(this.postForm));
    console.warn("postForm", this.postForm);
    this.$emit("input", backup);
    this.$emit("change", backup);
  }
  validateQUESTIONNAIRE(rule: any, value: any, callback: any) {
    let index = Number(rule.field.split(".")[2]);
    console.log("validateQUESTIONNAIRE", index);
    // 检测组件没有被删除
    if (
      !this.computedQuestionnaireItems.some((item: any) => {
        return item.data.id == value;
      })
    ) {
      return callback(Error("组件已删除或不满足计算条件，请修改组件"));
    }

    if (index < this.postForm.jsonConfig.calculatorList.length - 1) {
      console.log("validateQUESTIONNAIREindex", index, this.postForm.jsonConfig.calculatorList);

      //不是最后一个组件 需要检测后面跟的必须是判定条件
      if (this.postForm.jsonConfig.calculatorList[index + 1].type != "OPERATOR") {
        return callback(Error("题目后需要设置运算符"));
      }
    }
    callback();
  }
  validateFACTORS(rule: any, value: any, callback: any) {
    let index = Number(rule.field.split(".")[2]);

    if (index < this.postForm.jsonConfig.calculatorList.length - 1) {
      //不是最后一个组件 需要检测后面跟的必须是判定条件
      if (this.postForm.jsonConfig.calculatorList[index + 1].type != "OPERATOR") {
        return callback(Error("系数后需要设置运算符"));
      }
    }
    callback();
  }
  validateOPERATOR(rule: any, value: any, callback: any) {
    let index = Number(rule.field.split(".")[2]);

    // 检测组件没有被删除
    if (index == 0 || index == this.postForm.jsonConfig.calculatorList.length - 1) {
      return callback(Error("运算符不能在第一个和最后一个"));
    }

    if (index < this.postForm.jsonConfig.calculatorList.length - 1) {
      //不是最后一个组件 需要检测后面跟的必须是判定条件
      if (this.postForm.jsonConfig.calculatorList[index + 1].type == "OPERATOR") {
        return callback(Error("运算符后不能接运算符"));
      }
    }
    callback();
  }
  emitChange() {
    const backup = JSON.parse(JSON.stringify(this.postForm));
    this.$emit("input", backup);
    this.$emit("change", backup);
  }

  removeOption(item: { value: string }, index: number) {
    this.postForm.jsonConfig.calculatorList.splice(index, 1);
    this.emitChange();
  }
  get questionnaireType(): EnumCommunityType {
    return QuestionnaireEditModule.questionnaireType as any;
  }
  get communityType(): EnumCommunityType {
    return this.$route.path.includes("newCommunity") ? EnumCommunityType.DOCTOR : EnumCommunityType.PATIENT;
  }
  get computedQuestionnaireItems() {
    return QuestionnaireEditModule.calculatorQuestionnaireItems as any;
  }
  get scoreVerificationRule(): IScoreVerificationRule | undefined {
    const scoreVerificationList = this.postForm.jsonConfig.scoreVerificationList;
    return Array.isArray(scoreVerificationList) ? scoreVerificationList[0] : undefined;
  }
  // get questionnaireItems() {
  //   return QuestionnaireEditModule.calculatorQuestionnaireItems as any;
  // }
  get basicParams(): any {
    return {
      businessType: this.questionnaireType,
      communityType: this.communityType,
    };
  }

  addCalculatorList(type: string) {
    this.postForm.jsonConfig.calculatorList.push({
      type,
      value: "",
    });
  }

  // 开启校验时初始化唯一一条规则，关闭时保留原配置
  onScoreVerificationEnabledChange(enabled: boolean) {
    if (!Array.isArray(this.postForm.jsonConfig.scoreVerificationList)) {
      this.$set(this.postForm.jsonConfig, "scoreVerificationList", []);
    }
    if (enabled && this.postForm.jsonConfig.scoreVerificationList.length === 0) {
      this.postForm.jsonConfig.scoreVerificationList.push(this.createScoreVerificationRule());
    }
  }
  // 创建待填写的分数校验规则
  createScoreVerificationRule(): IScoreVerificationRule {
    return {
      operate: "",
      score: null,
      verificationResult: "",
    };
  }
  // 校验分数只能填写包含 0 的非负整数
  validateScoreVerificationScore(rule: any, value: number | null | undefined, callback: (error?: Error) => void) {
    if (value === undefined || value === null) {
      return callback(Error("请输入分数"));
    }
    if (!Number.isInteger(value) || value < 0) {
      return callback(Error("请输入大于等于0的整数"));
    }
    callback();
  }
  getFormInstance() {
    return this.$refs.postForm as any;
  }
  validateOptions() {
    this.getFormInstance().validateField("optionsList");
  }
  resetFields() {
    this.getFormInstance().resetFields();
  }

  async validate() {
    console.log("calcul validate");
    return await this.getFormInstance()
      .validate()
      .catch((err: any) => {
        return err;
      });
  }
  clearValidate() {
    if (this.getFormInstance()) {
      this.getFormInstance().clearValidate();
    }
  }
}
